<script>
    import { Router, Route } from 'svelte-routing';
    import Notifications from 'svelte-notifications';

    import { ROOT_PATH } from './config';
    import JobList from './pages/JobList.svelte';
    import Job from './pages/Job.svelte';
    import Offer from './pages/Offer.svelte';
    import CompleteDiscrepancy from './pages/CompleteDiscrepancy/CompleteDiscrepancy.svelte';
    import PreferredTime from './pages/PreferredTime/PreferredTime.svelte';
    import ResolveNonRoutine from './pages/ResolveNotRoutine/ResolveNonRoutine.svelte';
    import AddCompliance from './pages/AddCompliance/AddCompliance.svelte';
    import NotFound from './pages/NotFound.svelte';
</script>

<Notifications>
    <div class="wrapper">
        <Router basepath={ROOT_PATH}>
            <Route path="/jobs/" component="{JobList}" />
            <Route path="/job/:id" component="{Job}" />
            <Route path="/preferred-time/:uid" component="{PreferredTime}" />
            <Route path="/offer/" component="{Offer}" />
            <Route path="/complete-discrepancy/:uid" component="{CompleteDiscrepancy}" />
            <Route path="/non-routine/:uid/resolve" component="{ResolveNonRoutine}" />
            <Route path="/maintenance/:uid/add-compliance" component="{AddCompliance}" />
            <Route component="{NotFound}" />
        </Router>
    </div>
</Notifications>

<style global>
    @import 'filepond/dist/filepond.css';

    .wrapper {
        max-width: 620px;
        margin: 0 auto;
    }

    @media (max-width: 640px) {
        .wrapper {
            width: calc(100vw - 20px);
            margin: 10px;
        }
    }

    .preloader {
        padding: 20px;
        text-align: center;
    }
</style>
